import "@components/base/gsapFeatures";
import "@components/sections/models";
import "@components/sections/accessories";
import "@components/sections/nav";
import "@components/sections/technology";
import "@components/sections/specs";
import "@components/sections/contact";
import "@components/sections/gallery";
import "./language-switcher";
